module.exports = "/images/vendor/vue-paycard/src/dinersclub.png?ecd9dc4264a5218770ccdf1b8f74300c";